import React from 'react';
import { Link } from 'react-router-dom';
import { brandPath, mainSiteHref } from '../utils/brandRouting';
import { RELEASE_LABEL, RELEASE_MANIFEST_PATH, SUPPORT_EMAIL, products } from '../data/siteContent';

const CARDCYCLE = products.find((product) => product.id === 'cardcycle');

export default function CCFooter() {
  const backHref = mainSiteHref();
  return (
    <footer className="cc-footer" data-testid="cc-footer">
      <div className="wrap">
        <div className="cc-footer-brand">Card<span>Cycle</span></div>
        <p style={{ fontSize: '0.88rem' }}>{CARDCYCLE.description}</p>
        <div className="cc-footer-links">
          <Link to={brandPath('cardcycle', '/privacy')}>Privacy Notice</Link>
          <Link to={brandPath('cardcycle', '/terms')}>Terms of Use</Link>
          <Link to={brandPath('cardcycle', '/faq')}>FAQ</Link>
          <Link to={brandPath('cardcycle', '/account-deletion')}>Data Deletion</Link>
          <a href={`mailto:${SUPPORT_EMAIL}`}>Support</a>
          {backHref ? <a href={backHref}>TickleApps</a> : <Link to="/">TickleApps</Link>}
          <a href={RELEASE_MANIFEST_PATH} data-testid="cc-release-marker">{RELEASE_LABEL}</a>
        </div>
        <p className="cc-footer-copy">&copy; {new Date().getFullYear()} TickleApps. All rights reserved. CardCycle is a personal reminder tool and is not a bank, card issuer, or payment processor.</p>
      </div>
    </footer>
  );
}
